import axios, { type AxiosRequestConfig } from 'axios';

const personalAccessApi = axios.create({
  baseURL: `${import.meta.env.VITE_DEEPSIGN_API_BASE_URL}/v1/`
});

export const obtainPersonalAccessToken = (
  signKey: string,
  config: AxiosRequestConfig
) =>
  personalAccessApi.post(
    `/p/sign/${signKey}/personal-access-token`,
    undefined,
    {
      ...config
      // Expires param is for session expiration testing
      //  params: { expires: constants.SESSION_DURATION }
    }
  );
